import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CenterPanel from './centerPanel';
import RightPanel from './rightPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import Info from '../../info';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { useStringValidation } from 'businessLogic/helperHooks';

// There are shared states and function between center panel and right panel
function CenterAndRightPanelComponent(props) {
  const [canEditMessages, setCanEditMessages] = useState(props.shareLinkMessageForm.staffCanEditMessages);
  const [additionalEmailMessage, setAdditionalEmailMessage] = useState(
    props.shareLinkMessageForm.additionalEmailMessage
  );
  const [additionalTextMessage, setAdditionalTextMessage] = useState(props.shareLinkMessageForm.additionalTextMessage);

  const textMessageCharacterLimit = 100;
  const emailMessageCharacterLimit = 255;

  const emailMessageValidState = useStringValidation({
    checkCharacterLimt: true,
    characterLimt: emailMessageCharacterLimit,
    checkASCII: true,
    str: additionalEmailMessage,
  });

  const textMessageValidState = useStringValidation({
    checkCharacterLimt: true,
    characterLimt: textMessageCharacterLimit,
    checkASCII: true,
    str: additionalTextMessage,
  });

  return (
    <React.Fragment>
      <div className="content body-content">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel" style={{ minHeight: '400px' }}>
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel
                  canEditMessages={canEditMessages}
                  additionalEmailMessage={additionalEmailMessage}
                  additionalTextMessage={additionalTextMessage}
                  waitingAreaId={props.waitingAreaId}
                  textMessageValidState={textMessageValidState}
                  emailMessageValidState={emailMessageValidState}
                  updateOrView={props.updateOrView}
                />
              </div>
            </div>
            <CenterPanel
              originalMessage={props.shareLinkMessageForm.message}
              lockStaffCanEditFunction={props.shareLinkMessageForm.lockStaffCanEditFunction}
              canEditMessages={canEditMessages}
              setCanEditMessages={setCanEditMessages}
              additionalEmailMessage={additionalEmailMessage}
              setAdditionalEmailMessage={setAdditionalEmailMessage}
              additionalTextMessage={additionalTextMessage}
              setAdditionalTextMessage={setAdditionalTextMessage}
              textMessageCharacterLimit={textMessageCharacterLimit}
              textMessageValidState={textMessageValidState}
              emailMessageValidState={emailMessageValidState}
              emailMessageCharacterLimit={emailMessageCharacterLimit}
              updateOrView={props.updateOrView}
            />
            <div className="bottom-rail-with-left-and-right-content mrtl">
              <div className="mrtm">
                <Info
                  paragraphs={[APP.LANGUAGE.ShareLinkSharedText.InfoText1, APP.LANGUAGE.WaitingAreaShareLink.InfoText2]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-rail-with-left-and-right-content mrtnull">
        <RightPanel
          canEditMessages={canEditMessages}
          additionalEmailMessage={additionalEmailMessage}
          additionalTextMessage={additionalTextMessage}
          waitingAreaId={props.waitingAreaId}
          textMessageValidState={textMessageValidState}
          emailMessageValidState={emailMessageValidState}
          updateOrView={props.updateOrView}
        />
      </div>
    </React.Fragment>
  );
}

export default function WAShareLinkMessageModalContainer(props) {
  let waName = props.waitingArea ? props.waitingArea.name : '';
  const shareLinkMessageForm = useSelector((state) => state.waitingAreaReducer.shareLinkMessageForm);

  return (
    <Modal show={true} hideWhenClickAway={false} className="share-wa-link fixed-header-footer-mobile">
      <PopupHeader
        title={APP.LANGUAGE.WaitingAreaShareLink.Title}
        subtitle={waName}
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpShareWALink}
      />
      <Container fluid as={Media} at="mobile" className="content-container">
        <div className="bold title-sms text-size-l mrtl mrbs">{APP.LANGUAGE.ShareLinkSharedText.Header}</div>
        <hr className="mrtnull" style={{ border: '1px solid #e6e6e6' }} />
      </Container>
      <CenterAndRightPanelComponent
        waitingAreaId={props.waitingArea.id}
        shareLinkMessageForm={shareLinkMessageForm}
        updateOrView={props.updateOrView}
      />
    </Modal>
  );
}
